import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import '../assets/css/signin.scss'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import googleIcon from '../assets/images/signin/google.png'
import linkedIcon from '../assets/images/signin/linkedin.png'
import companyLogo from '../assets/images/signin/logo-dark-copy.png'
import { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { loadCountryCodeDropdown, postSignUpUserData } from './redux/action';
import * as HeaderAuthentication from '../components/HeaderAuthentication'

const SignUp = () => {
    let dispatch = useDispatch();
    const navigate = useNavigate();
    const { countryCodeDropdown } = useSelector((state) => state.data);

    const [formData, setFormData] = useState({
        user_name: '',
        mobile_code: { label: '+91', value: '+91' },
        to_email: '',
        phone: '',
        company_name: '',
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        dispatch(loadCountryCodeDropdown());
    }, [])

    let hideSwal = false;
    const tokenClientRef = useRef(null);

    useEffect(() => {
        if (window.google?.accounts?.oauth2) {
            tokenClientRef.current = window.google.accounts.oauth2.initTokenClient({
                client_id: '762425997431-plapsidtr0nm2kjfkc9vrk6vcv2lsfa2.apps.googleusercontent.com',
                scope: 'openid profile email https://www.googleapis.com/auth/user.phonenumbers.read',
                callback: async (tokenResponse) => {

                    try {
                        // Call People API to get phone number
                        const res = await fetch('https://people.googleapis.com/v1/people/me?personFields=phoneNumbers,emailAddresses,names', {
                            headers: {
                                Authorization: `Bearer ${tokenResponse.access_token}`,
                            },
                        });

                        const data = await res.json();

                        // Extract name, email, and phone number
                        const name = data.names ? data.names[0].displayName : '';
                        const email = data.emailAddresses ? data.emailAddresses[0].value : '';
                        const phoneNumber = data.phoneNumbers ? data.phoneNumbers[0].value : '';

                        const userData = {
                            name,
                            email,
                            "mobile_code": "",
                            phoneNumber,
                            "company_name": "",
                        };
                        hideSwal = true;
                        handleSignUp(userData);

                    } catch (error) {
                        console.error('Failed to fetch phone number:', error);
                    }
                },
            });
        }
    }, []);

    const validate = () => {
        const newErrors = {};
        if (!formData.user_name.trim()) newErrors.user_name = 'Full name is required';
        if (!formData.to_email.trim()) newErrors.to_email = 'Email address is required';
        if (!formData.phone.trim()) newErrors.phone = 'Phone number is required';
        return newErrors;
    };

    const handleChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
        setErrors((prev) => ({
            ...prev,
            [field]: '',
        }));
    };

    const AddSignUpData = (e) => {
        e.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const signUpData = {
            user_name: formData.user_name,
            mobile_code: formData.mobile_code.value,
            to_email: formData.to_email,
            phone: formData.phone,
            company_name: formData.company_name,
            flagged:true
        };
        hideSwal = false;
        handleSignUp(signUpData);
    };

    const handleSignUp = (data) => {
        console.log(data,'data')
        const signUpData = {
            user_name: data.user_name,
            mobile_code: data.mobile_code,
            to_email: data.to_email,
            phone: data.phone,
            company_name: data.company_name,
            flagged:true
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postAuthOfLeadMerge,
            body: JSON.stringify(signUpData),
        };

        dispatch(postSignUpUserData(requestOption, hideSwal, data.email));
        console.log(signUpData, 'signUpData')
    }

    const handleGetPhone = () => {
        if (tokenClientRef.current) {
            tokenClientRef.current.requestAccessToken();
        } else {
            console.error("Token client not initialized");
        }
    };

    const handleLinkedInLogin = () => {
        const clientId = "86opkgjrw1jcp4";
        const redirectUri = "https://gfcb8ed8eb8355a-st94sy8hnd7n7e0g.adb.ap-mumbai-1.oraclecloudapps.com/ords/leadmerge/lm_login/oauth/linkedin/callback";
        const state = crypto.randomUUID(); // generate random state for security
        const scope = "openid profile email"; // ✅ new scopes

        const authUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(
            redirectUri
        )}&scope=${encodeURIComponent(scope)}&state=${state}`;

        window.location.href = authUrl;
    };

    useEffect(() => {
        const handleLinkedInCallback = async () => {
            const params = new URLSearchParams(window.location.search);
            console.log(params, 'params')
            const code = params.get("code");
            const state = params.get("state");
            console.log(code, 'code')
            if (!code) {
                console.error("No LinkedIn code returned");
                return;
            }

            try {
                // 1. Exchange code for token (call your ORDS backend)
                const tokenRes = await fetch(
                    "https://gfcb8ed8eb8355a-st94sy8hnd7n7e0g.adb.ap-mumbai-1.oraclecloudapps.com/ords/leadmerge/lm_login/api/linkedin/token",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ code })
                    }
                );
                const { access_token } = await tokenRes.json();

                // 2. Fetch LinkedIn profile
                const profileRes = await fetch("https://api.linkedin.com/v2/userinfo", {
                    headers: { Authorization: `Bearer ${access_token}` }
                });
                const profile = await profileRes.json();

                const signUpData = {
                    user_name: profile.name,
                    mobile_code: "",
                    to_email: profile.email,
                    phone: "",
                    company_name: ""
                };

                // 3. Send to your backend
                let requestOption = {
                    method: "POST",
                    mode: "cors",
                    headers: HeaderAuthentication.postAuthOfLeadMerge,
                    body: JSON.stringify(signUpData),
                };

                dispatch(postSignUpUserData(requestOption, true, profile.email));

                // 4. Redirect user
                navigate("/dashboard");
            } catch (err) {
                console.error("LinkedIn login failed:", err);
            }
        };

        handleLinkedInCallback();
    }, [dispatch, navigate]);

    return (
        <Container fluid className="signin-container">
            <Row className="signin-row">
                {/* Left Column - Image */}
                <Col md={6} className="signin-first-col">
                    <dotlottie-player
                        src="https://lottie.host/38083418-3526-4b48-947a-c2f397e7f5df/uJRHRxuGKS.lottie"
                        background="transparent"
                        speed="1"
                        loop
                        autoplay
                        className='lottie-img'
                    ></dotlottie-player>
                </Col>

                {/* Right Column - Form */}
                <Col md={6} className="signin-second-col">
                    <img src={companyLogo} className='companyLogo' alt="" />
                    <h6 className="text-center">Create a new account</h6>
                    <span>Get your Leadmerge account now.</span>
                    <Form className='signin-form-container' onSubmit={AddSignUpData}>
                        <Form.Group className="mb-3" controlId="formName">
                            <Form.Control
                                type="text"
                                placeholder="Your Full Name"
                                value={formData.name}
                                onChange={(e) => handleChange('user_name', e.target.value)}
                            />
                            {errors.user_name && <div className="text-danger">{errors.user_name}</div>}
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formEmail">
                            <Form.Control
                                type="email"
                                placeholder="Email Address"
                                value={formData.email}
                                onChange={(e) => handleChange('to_email', e.target.value)}
                            />
                            {errors.to_email && <div className="text-danger">{errors.to_email}</div>}
                        </Form.Group>

                        <Form.Group controlId="formPhone" className='mb-3'>
                            <div className="d-flex align-items-center">
                                <div style={{ width: '20%' }}>
                                    <Select
                                        options={countryCodeDropdown}
                                        value={formData.mobile_code}
                                        onChange={(selectedOption) => handleChange('mobile_code', selectedOption)}
                                    />
                                </div>
                                <Form.Control
                                    type="tel"
                                    placeholder="Phone Number"
                                    className="ms-2"
                                    style={{ width: '80%' }}
                                    value={formData.phone}
                                    onChange={(e) => handleChange('phone', e.target.value)}
                                />
                            </div>
                            {errors.phone && <div className="text-danger">{errors.phone}</div>}
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formCompany">
                            <Form.Control
                                type="text"
                                placeholder="Company Name (Optional)"
                                value={formData.company}
                                onChange={(e) => handleChange('company_name', e.target.value)}
                            />
                            {errors.company_name && <div className="text-danger">{errors.company_name}</div>}
                        </Form.Group>

                        <Button variant="primary" type="submit" className="w-100">
                            Sign Up
                        </Button>

                        <div className="divider-container">
                            <div className="line"></div>
                            <p className="text">Or continue with</p>
                            <div className="line"></div>
                        </div>
                        <div className='lm-login-btns-section'>
                            <div className='btn-div' onClick={handleGetPhone}>
                                <img src={googleIcon} alt="" />
                            </div>
                            <div className='btn-div' onClick={handleLinkedInLogin}>
                                <img src={linkedIcon} alt="" />
                            </div>
                        </div>
                        <div className='signin-signup-link'>
                            <p>Already have an account? <Link to='/'> Sign In </Link></p>
                        </div>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default SignUp;
